export const nextChatStep = ({commit}, value) => {
  commit('INCREASE_CHAT_STEP', value)
}

export const triggerReply = ({commit}) => {
  commit('TRIGGER_REPLY')
}

export const triggerScrollWindow = ({commit}, value) => {
  commit('TRIGGER_SCROLL_WINDOW', value)
}

export const updateEarthPos = ({commit}, value) => {
  commit('UPDATE_EARTH_POS', value)
}

export const updateAvatarPos = ({commit}, value) => {
  commit('UPDATE_AVATAR_POS', value)
}

export const setSelectedAnswer = ({commit}, value) => {
  commit('SET_SELECTED_ANSWER', value)
}

export const isRightReply = ({commit}, value) => {
  commit('SET_RIGHT_REPLY', value)
}

export const openOverlay = ({commit}, overlayType) => {
  commit('SET_OVERLAY_TYPE', overlayType)
}

export const setMenuCtaVisibility = ({commit}, value) => {
  commit('SET_MENU_CTA_VISIBILITY', value)
}

export const browseChatFromMenu = ({commit}, value) => {
  commit('IS_BROWSING_FROM_MENU', value)
}

export const changeBgIndex = ({commit}, value) => {
  commit('CHANGE_BG_INDEX', value)
}
export const updateCurrentBgIndex = ({commit}, value) => {
  commit('CURRENT_BG_INDEX', value)
}

export const openBadge = ({commit}, badgeType) => {
  commit('SET_BADGE_TYPE', badgeType)
}

export const selectBadge = ({commit}, badgeType) => {
  commit('SELECT_BADGE', badgeType)
}

export const endChat = ({commit}) => {
  commit('END_CHAT')
}